/** @format */

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getKnowledgeBaseLink } from 'src/utils/helper';
import { setKnowledgeBaseDetailPreview } from 'src/slices/knowledgeBase';
import { Rating } from '../Rating';

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };

export const KnowledgeBaseItem = ({ kb, item }) => {
  const dispatch = useDispatch();
  const { nid, title, date, category, content, rating } = item;
  const handleClickItem = () => {
    dispatch(setKnowledgeBaseDetailPreview({ title }));
  };
  return (
    <Link to={getKnowledgeBaseLink(kb, item)} onClick={handleClickItem} className="knowledge_base-widget--list-item">
      <Grid className="knowledge_base-widget--list-item-top">
        <Grid className="knowledge_base-widget--list-item-date-title">
          <Grid className="knowledge_base-widget--list-item-title">{title}</Grid>
          <Grid className="knowledge_base-widget--list-item-date">
            {format(new Date(date * 1000), 'dd.MM.yyyy') || '00.00.0000'}
          </Grid>
        </Grid>
        {rating && rating !== 0 ? <Rating rating={rating} /> : null}
      </Grid>
      <Grid className="knowledge_base-widget--list-item-text">{content}</Grid>
    </Link>
  );
};

export const KnowledgeBaseItemSkeleton = () => {
  return (
    <Grid className="knowledge_base-widget--list-item knowledge_base-widget--list-item--skeleton">
      <Grid className="knowledge_base-widget--list-item-top">
        <Grid className="knowledge_base-widget--list-item-date-title">
          <Grid className="knowledge_base-widget--list-item-title">
            <Skeleton variant="text" width={200} height={28} style={skeletonStyle} />
          </Grid>
          <Grid className="knowledge_base-widget--list-item-date">
            <Skeleton variant="text" width={80} height={20} style={skeletonStyle} />
          </Grid>
        </Grid>
        <Skeleton variant="text" width={120} height={24} style={skeletonStyle} />
      </Grid>
      <Grid className="knowledge_base-widget--list-item-text">
        <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
        <Skeleton variant="text" width="75%" height={20} style={skeletonStyle} />
      </Grid>
    </Grid>
  );
};

export const KnowledgeBaseListSkeleton = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <KnowledgeBaseItemSkeleton key={index} />
      ))}
    </>
  );
};

export const KnowledgeBaseDetailContentSkeleton = () => {
  return (
    <Grid className="knowledge-base-detail-skeleton__content" style={{ marginTop: 32 }}>
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="95%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="80%" height={20} style={skeletonStyle} />
      <Skeleton
        variant="rect"
        width="100%"
        height={200}
        style={{ ...skeletonStyle, marginTop: 16, marginBottom: 16 }}
      />
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="90%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
      <Skeleton variant="text" width="70%" height={20} style={skeletonStyle} />
    </Grid>
  );
};

export const KnowledgeBaseDetailSkeleton = () => {
  return (
    <Grid className="knowledge-base-detail-skeleton">
      <Grid className="knowledge-base-detail-skeleton__header">
        <Grid className="knowledge-base-title-box">
          <Skeleton variant="text" width="70%" height={40} style={skeletonStyle} />
        </Grid>
        <Grid
          className="knowledge-base-rating"
          style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 16 }}
        >
          <Skeleton variant="rect" width={120} height={24} style={skeletonStyle} />
          <Skeleton variant="text" width={100} height={20} style={skeletonStyle} />
        </Grid>
        <Grid style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <Skeleton variant="rect" width={80} height={28} style={{ ...skeletonStyle, borderRadius: 4 }} />
          <Skeleton variant="rect" width={100} height={28} style={{ ...skeletonStyle, borderRadius: 4 }} />
          <Skeleton variant="rect" width={90} height={28} style={{ ...skeletonStyle, borderRadius: 4 }} />
        </Grid>
      </Grid>
      <KnowledgeBaseDetailContentSkeleton />
    </Grid>
  );
};

export const KnowledgeBasePageSkeleton = () => {
  return (
    <Grid className="knowledge-base-page-skeleton">
      <Grid className="knowledge-base-title-box">
        <Skeleton variant="text" width="40%" height={64} style={skeletonStyle} />
      </Grid>
      <Grid style={{ marginTop: 16, marginBottom: 24 }}>
        <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
        <Skeleton variant="text" width="80%" height={20} style={skeletonStyle} />
      </Grid>
      <Grid className="knowledge-base-categories-sort">
        <Skeleton variant="text" width={120} height={40} style={skeletonStyle} />
        <Grid style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <Skeleton variant="rect" width={60} height={32} style={{ ...skeletonStyle, borderRadius: 4 }} />
          <Skeleton variant="rect" width={120} height={32} style={{ ...skeletonStyle, borderRadius: 4 }} />
          <Skeleton variant="rect" width={80} height={32} style={{ ...skeletonStyle, borderRadius: 4 }} />
          <Skeleton variant="rect" width={120} height={32} style={{ ...skeletonStyle, borderRadius: 4 }} />
        </Grid>
      </Grid>
      <Grid className="knowledge_base-widget--list knowledge-base-list">
        <KnowledgeBaseListSkeleton count={5} />
      </Grid>
    </Grid>
  );
};
